import { useEffect } from 'react';
import { getLanguage, setLanguage } from '../Translations/languageManager';
import { useGlobalState } from './globalState';

const LanguageSync = () => {
  const { globalState } = useGlobalState();

  useEffect(() => {
    if (globalState?.language && globalState.language !== getLanguage()) {
      setLanguage(globalState.language);
    }
  }, [globalState.language]);

  return null;
};

export default LanguageSync;
